$(document).ready(function() {
    // Attach click event to tab headers
    $(".m-tab-bar-item").click(function() {
        const tabIndex = $(this).index(); // Get index of clicked tab item
        $(".m-tab-bar-item").removeClass("active"); // Remove active class from all tab items
        $(this).addClass("active"); // Add active class to clicked tab item
        $(".accordion-item").children(".accordion-content").eq(tabIndex).addClass("active"); // Add active class to corresponding accordion item
        $(".accordion-item").children(".accordion-header").eq(tabIndex).children("i").addClass("active")
    });

    // Attach click event to accordion headers
    $(".accordion-item").on("click", function(event) {
        var thiss2 = $(this).children(".accordion-header");
        const accordionIndex = $(this).index(); // Get index of clicked accordion item
        $(".m-tab-bar-item").removeClass("active");
         // Remove active class from all tab items
        if ($(this).children(".accordion-content").hasClass("active")) {
            if ($(event.target).is(thiss2)) {
                $(this).children(".accordion-content").removeClass("active");
                $(this).children(".accordion-header").children("i").removeClass("active");
            }
        } else {
            $(this).children(".accordion-content").addClass("active"); // Add active class to clicked accordion item
            $(this).children(".accordion-header").children("i").addClass("active")
        }
        $(".m-tab-bar-item").eq(accordionIndex).addClass("active"); // Add active class to corresponding tab item
    });

    //  scroll down to its section
    $('.m-tab-bar-item a').on('click', function(e) {
        e.preventDefault();
        const target = $($(this).attr('href'));

        if (target.length) {
            const scrollTo = target.offset().top - 140;
            $('html, body').animate({
                scrollTop: scrollTo
            }, 300);
        }
    });

    // on scroll move tabbar
function sticky_relocate() {
    var window_top = $(window).scrollTop();
    var funciones = $('#funciones').offset().top - 110;
    var tabBarRow = $('.m-tab-bar').get(0); // get DOM element from jQuery object
    var scrollLeft = window_top > funciones ? 350 : -350;

    if ('scrollBehavior' in document.documentElement.style) {
        // Use native smooth scrolling if available
        tabBarRow.scrollBy({
            left: scrollLeft,
            behavior: 'smooth'
        });
    } else {
        // Fallback to jQuery animate for smooth scrolling
        $('.m-tab-bar').animate({ scrollLeft: "+=" + scrollLeft }, 'slow');
    }
}

    $(window).scroll(sticky_relocate);
    // sticky_relocate();

if (window.innerWidth > 768) {
        $('.small-device-video').remove();
        $('.owl-carousel').owlCarousel({
            loop: true,
            margin: 50,
            dots: true,
            nav: false,
            responsive: {
                0: {
                    items: 1
                },
                600: {
                    items: 1
                },
                1000: {
                    items: 3
                }
            }
        });
    }
  
if (window.innerWidth < 768) {
        $('.large-device-video').remove();
    }
});